export default __webpack_public_path__ + "static/media/logo.be61ba0c.svg";